import gql from 'graphql-tag';
import formFieldFragment from './formFieldFragment';
import memberFragment from './memberFragment';

export default gql`
  ${formFieldFragment}
  ${memberFragment}

  fragment authFragment on MemberToken {
    token
    cdnToken
    action
    accountStatus
    formFields: missingDetails {
      ...formFieldFragment
    }
    member {
      ...memberFragment
    }
  }
`;
